/**
 * @desc 侧边栏任务卡片组件
 */

import { useEffect, useState, useCallback } from 'react';
import { TipCard } from '@tencent/tpm-trtc-console';
import { ArrowRightIcon } from '@tencent/tpm-audio-video-react-icons';
import { eventBus } from '@src/utils/tools/eventBus';

interface TaskCardData {
  title: string;
  description?: string;
  buttonText: string;
  buttonStatus: string;
}

export const MenuTaskCard = () => {
  const [cardData, setCardData] = useState<TaskCardData | null>(null);
  const [isCollapse, setIsCollapse] = useState(false);

  useEffect(() => {
    return eventBus.on('taskCardUpdate', (data: TaskCardData) => {
      setCardData(data);
    });
  }, []);

  const handleButtonClick = useCallback(() => {
    if (!cardData) return;
    eventBus.dispatch('taskCardButtonClick', {
      buttonStatus: cardData.buttonStatus,
    });
  }, [cardData]);

  const handleCollapseClick = useCallback(() => {
    setIsCollapse(prev => !prev);
  }, []);

  if (!cardData) return null;

  return (
    <TipCard
      style={{ width: 'calc(100% - 12px)' }}
      version="v2"
      isCollapse={isCollapse}
      title={cardData.title}
      description={cardData.description}
      showIcon
      button={
        <a
          onClick={handleButtonClick}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          {cardData.buttonText}
          <ArrowRightIcon size={16} color="#E0794C" />
        </a>
      }
      onCollapseClick={handleCollapseClick}
    />
  );
};
